import { createContext } from 'react';
import { FlashcardController } from './types';

// eslint-disable-next-line
export const FlashcardContext = createContext<FlashcardController | null>(null);

export type FlashcardProviderProps = {
  controller: FlashcardController;
};

export function FlashcardProvider({
  controller,
  ...others
}: React.PropsWithChildren<FlashcardProviderProps>) {
  return <FlashcardContext.Provider {...others} value={controller} />;
}

FlashcardProvider.displayName = 'FlashcardProvider';
